import React, { useState, useEffect } from 'react';
import { ActivityLogIcon } from "../../icons/Icons";
import { Modal } from 'react-bootstrap';
import ActivityLogModal from "./ActivityLogModal";
import { useDispatch } from "react-redux";
import {
  getUserProfileAsync,
  getNotificationsAsync,
} from "../../reducers/user-reducers";

const ActivityLog = () => {
    const [modalActivityLog, setModalActivityLog] = useState(false);

    const dispatch = useDispatch();
    const [userProfiles, setUserProfiles] = useState(null);
    const [activeTab, setActiveTab] = useState("All");
    const [readNotification, setReadNotification] = useState(false);

    useEffect(() => {
        getUserProfile();
    }, []);

    useEffect(() => {
        getNotification();
    }, [userProfiles, modalActivityLog]);

    const getUserProfile = () => {
        dispatch(getUserProfileAsync()).then((res) => {
          if (res.payload) {
            setUserProfiles(res.payload);
          }
        });
    };

    const getNotification = async () => {
        const reqBody = {
            page: 1,
            pageSize: 10,
            orderBy: "",
            isOrderByDesc: true,
            searchString: '',
            userId: userProfiles?.employeeId,
            // userId: "AFCA5765-3AF9-4D35-C12B-08DBE83C92EC",
            apiType: activeTab,
        };
        const response = await dispatch(getNotificationsAsync(reqBody));
        if (response.payload) {
            setReadNotification(response?.payload?.totalUnreadRecords > 0 ? true : false);
        }
    };

    return (
        <>
            <div>
                <button onClick={() => setModalActivityLog(true)} className="hamberger">
                    <ActivityLogIcon />
                    {readNotification === true && (
                        <span className='dot top-0 end-0'></span>
                    )}
                </button>
            </div>
            <Modal className="come-from-modal right" centered show={modalActivityLog} onHide={() => setModalActivityLog(false)}>
                <ActivityLogModal handleModal={setModalActivityLog} />
            </Modal>
        </>
    );
}

export default ActivityLog;
